const faqContent = [
  {
    question: "The standard Lorem Ipsum passage, used since the 1500s",
    answer: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.`,
  },
  {
    question: "The standard Lorem Ipsum passage, used since the 1500s",
    answer: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.`,
  },
  {
    question: "The standard Lorem Ipsum passage, used since the 1500s",
    answer: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.`,
  },
  {
    question: "The standard Lorem Ipsum passage, used since the 1500s",
    answer: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.`,
  },
  {
    question: "The standard Lorem Ipsum passage, used since the 1500s",
    answer: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.`,
  },
  {
    question: "The standard Lorem Ipsum passage, used since the 1500s",
    answer: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.`,
  },
  {
    question: "The standard Lorem Ipsum passage, used since the 1500s",
    answer: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.`,
  },
];

export default faqContent;
